import { Box } from '@mui/material';
import { type JSX, type SyntheticEvent } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTopHeader } from 'app/hooks';
import { Tabs } from 'app/shared-components/structure';
import type { HealtheraTab } from 'app/shared-components/structure/Tabs';
import FuseSuspense from '@/@fuse/core/FuseSuspense';

const tabs: HealtheraTab[] = [
  { label: 'Linkage Requests', value: 'linkage-requests' },
  { label: 'All Users', value: 'users' },
  { label: 'Email Log', value: 'email-log' },
];

const TAB_VALUES = tabs.map((tab) => tab.value);

export default function SupportDashboardLayout(): JSX.Element {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useTopHeader('Support dashboard');

  const lastSegment = pathname.split('/').pop() ?? '';
  const selectedTab = TAB_VALUES.includes(lastSegment) ? lastSegment : 'linkage-requests';

  const handleTabChange = (_event: SyntheticEvent, newTab: string): void => {
    navigate(`/support-dashboard/${newTab}`);
  };

  return (
    <Box className="vtwo:grow vtwo:flex vtwo:flex-col vtwo:overflow-hidden vtwo:px-5 vtwo:py-4 vtwo:gap-4">
      <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      <FuseSuspense>
        <Outlet />
      </FuseSuspense>
    </Box>
  );
}
